import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@ngneat/transloco';
import Utils from 'src/app/utils';

import timezones from 'timezones-list';

import * as _ from 'lodash-es';
declare var require: any;

@Component({
  selector: 'app-monitor-edit',
  templateUrl: './monitor-privacy-edit.component.html',
  styleUrls: ['./monitor-privacy-edit.component.scss']
})
export class MonitorPrivacyEditComponent implements OnInit {

  monitor: any;
  id?: number;

  formGroup = new FormGroup({
    name: new FormControl('',[
      Validators.required,
    ]),
    email: new FormControl('',[
      Validators.email,
      Validators.required,
    ]),
    phone: new FormControl('',[
      Validators.required,
    ]),
    phone2: new FormControl('',[
      Validators.required,
    ])
  });

  submitted = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  yesno = [{val:true,name:"Yes"},{val:false,name:"No"}]

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.id = +this.route.snapshot.params['id'];

    //console.log('id',this.id);

    this.formGroup.controls['name'].disable();
    this.formGroup.controls['email'].disable();
  

    
    if(this.okService.settings.arc_on){
      this.formGroup.setControl('phone',new FormControl('',[Validators.required]))
    }

    this.getMonitor();

    //console.log(this.passFormGroup);


  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();

  }

  getMonitor(){

    this.okService.get("monitors/privacy/"+this.id,[])
    .subscribe((data) => {

      this.monitor = data.body;

      //console.log(this.monitor);

      this.setForm();

    });
  }

  setForm(){
    this.formGroup.setValue({
      name: this.monitor.name,
      phone: this.monitor.phone,
      phone2: this.monitor.phone2,
      email: this.monitor.email,
    });

  }

  submitForm(){
    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values:any = this.formGroup.value

        // Update the contact values for the monitor
        let contact:any = [];

        values.contact = contact;


        this.okService.put("monitors/privacy/"+this.id,values)
        .subscribe({
          next: (data) => {

            this.monitor = data.body;

            //console.log("monitor",this.monitor);

            this.setForm();


            if(this.okService.session.id == this.id){
              this.okService.refreshUser();
            }


            this.okService.setAlert(this.transloco.translate("The monitor has been updated"),"success");
          },
          error: (e) => {

            //console.log("error",e);

            if(Array.isArray(e)){
              let self = this;
              // Use of _.forEach() method
              _.forEach(e, function(error:any) {
                //console.log(error);
                self.formGroup.get(error.field)?.setErrors({ invalid: error.message });
              });
            }else{
              this.okService.setAlert(e,"warning")
            }


          },
          complete: () => {
            //console.info('complete');
          }
      });


      }

    return false;
  }



}
